/**
 * Gets an iterator for the first given number of values.
 *
 * @yields The value.
 */
export function* take<T>(values: IterableIterator<T>, top: number): IterableIterator<T> {
  let i = 0;
  for (const value of values) {
    if (i === top) {
      break;
    }
    yield value;
    ++i;
  }
}

/**
 * Gets an iterator by skipping the given number of values.
 *
 * @yields The value.
 */
export function* skip<T>(values: IterableIterator<T>, skip: number): IterableIterator<T> {
  let i = 0;
  for (const value of values) {
    if (i >= skip) {
      yield value;
    }
    ++i;
  }
}
